<template>
    <div class="container-fluid login-bg">
        <div class="row">
            <div class="col-lg-6 offset-lg-3">
                <div class="card main-card">
                    <div class="card-body">
                        <div class="card-text text-center">
                            <span class="font-weight-bold ">Welcome to our community portal and Alice Springs</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 offset-lg-4">
                <div class="card main-card" style="margin-top:.5em;">
                    <div class="card-body">
                        <div class="card-text">
                            <div class="text-center">
                                <h4 class="gray-header">Register for Access</h4>
                                <router-link :to="{ name: 'register' }" tag="button" class="btn col-12 vesta-gray-btn col-lg-4">Register Here</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .gray-header {
        color: #707070;
    }
    
</style>

<script>
import {TokenService} from '../services/token.service'
export default {
    
    data() {
        return {
             loggedIn: false,
        }
    },
    mounted: function () {
        this.checkLoggedIn();
    },
    methods: {
        checkLoggedIn: function () {
            if (TokenService.getToken()) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        },
    }
}
</script>
